import { Controller } from '@hotwired/stimulus';

let dropdown;

export default class extends Controller {
  static targets = ['trigger', 'menu'];
  static classes = ['active'];

  connect() {
    this.isOpen = false;
    this.setupEventlisteners();
  }

  disconnect() {
    this.triggerTarget.removeEventListener('mouseenter', this.open);
    this.element.removeEventListener('mouseleave', this.close);
    this.menuTarget.removeEventListener('click', this.handleMenuClick);
  }

  setupEventlisteners() {
    this.triggerTarget.addEventListener('mouseenter', this.open);
    this.element.addEventListener('mouseleave', this.close);
    this.menuTarget.addEventListener('click', this.handleMenuClick);
  }

  handleMenuClick = (event) => {
    if (event.target.tagName === 'A') {
      this.close();
    }
  };

  open = () => {
    if (dropdown) {
      dropdown.close();
    }
    dropdown = this;
    this.element.classList.add(this.activeClass);
  };

  close = () => {
    this.element.classList.remove(this.activeClass);
  };
}
